import React, { useRef } from 'react';
import CommonUtils from 'utilities/common-utils';
import { timeZone } from 'interfaces/timezone-type';
import FilterItemMenu from './FilterItemMenu';
import { IFilter } from 'interfaces/filter-interfaces';
import { FilterType } from 'utilities/enum-utils';
import _ from 'lodash';
import { Button, Group, Menu, Text } from '@good/ui/core';
import { ChevronDown, ChevronUp } from '@good/icons';
import { useClickOutside } from '@good/ui/hooks';

export interface IActiveFilterItemProps {
  filter: IFilter;
  isOpen: boolean;
  setIsOpen: (filterType: FilterType, isOpen: boolean) => void;
  saveNewFilterValue: (filterType: FilterType, newFilterValue: any, selectionLabel: string) => void;
  removeFilter: (filterType: FilterType) => void;
  displayTimezone: timeZone;
  usePortal: boolean;
  canRemove?: boolean;
  dateFilterV2?: boolean;
}

export const ActiveFilterItem = ({
  filter,
  usePortal,
  saveNewFilterValue,
  setIsOpen,
  isOpen,
  removeFilter,
  canRemove,
  displayTimezone,
  dateFilterV2,
}: IActiveFilterItemProps) => {
  const isShowCustomTitle = [FilterType.BOOKING_BILLING, FilterType.BATCH_BILLING, FilterType.PAID_BILLING].includes(
    filter.filter,
  );
  const ref = useClickOutside(() => setIsOpen(filter.filter, false));

  return (
    <Menu shadow='md' position='bottom-start' opened={isOpen} withinPortal={usePortal}>
      <Menu.Target>
        <Button
          variant='light'
          size='sm'
          style={
            isOpen
              ? {
                  backgroundColor: 'var(--mantine-color-ocean-1)',
                }
              : undefined
          }
          rightSection={!isOpen ? <ChevronDown /> : <ChevronUp />}
          onClick={() => setIsOpen(filter.filter, !isOpen)}
        >
          <Group gap={6}>
            <Text fw={650} size='sm'>
              {isShowCustomTitle
                ? CommonUtils.getFilterSettings(filter.filter).customTitle
                : CommonUtils.getFilterSettings(filter.filter).title}
            </Text>
            <Text size='sm'>|</Text>
            <Text size='sm'>{filter.selectionLabel}</Text>
          </Group>
        </Button>
      </Menu.Target>
      <Menu.Dropdown p={0} ref={ref}>
        <FilterItemMenu
          filter={filter}
          saveNewFilterValue={saveNewFilterValue}
          removeFilter={removeFilter}
          canRemove={canRemove}
          displayTimezone={displayTimezone}
          dateFilterV2={dateFilterV2}
          onClose={() => setIsOpen(filter.filter, false)}
        />
      </Menu.Dropdown>
    </Menu>
  );
};
